import {combineReducers} from 'redux';
import * as a from './actionTypes'

// Remaining reducers — still read by components or action creators
// that haven't been refactored to apiPostAsync yet.

function appKey(state = '', action) {
  switch (action.type) {
    case a.USER_INPUT_APP_KEY_CHANGE:
      return action.data;
    default:
      return state;
  }
}

function tfaDeliveryPreference(state = '', action) {
  switch (action.type) {
    case a.USER_INPUT_TFA_DELIVERY_PREFERENCE_CHANGE:
      return action.data;
    default:
      return state;
  }
}

function continueLoginWithAppId(state = '', action) {
  switch (action.type) {
    case a.CONTINUE_WITH_APPID_CLICK:
      return action.data;
    default:
      return state;
  }
}

function PASSWORD_LESS_SAML_CONFIG(state = {}, action) {
  switch (action.type) {
    case a.PASSWORD_LESS_SAML_CONFIG:
      return action.data;
    default:
      return state;
  }
}

function changeEmailVerified(state = false, action) {
  switch (action.type) {
    case a.USER_INPUT_CHANGE_EMAIL_VERIFIED:
      return action.data;
    default:
      return state;
  }
}

function emailChanged(state = false, action) {
  switch (action.type) {
    case a.USER_INPUT_EMAIL_CHANGED:
      return action.data;
    default:
      return state;
  }
}

function otpSentSuccess(state = false, action) {
  switch (action.type) {
    case a.SEND_OTP_SUCCESS:
      return action.data;
    default:
      return state;
  }
}

export default combineReducers(
    {
      appKey,
      tfaDeliveryPreference,
      continueLoginWithAppId,
      PASSWORD_LESS_SAML_CONFIG,
      changeEmailVerified,
      emailChanged,
      otpSentSuccess
    }
)
